var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatabase({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "03-advices",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: 64,
    height: 64
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M40.7,21.8l14.6,0c0-0.6-0.1-1.2-0.3-1.7c-0.2-0.5-0.6-1-1-1.5c-0.4-0.4-0.9-0.8-1.5-1c-0.5-0.2-1.1-0.3-1.7-0.3l-10.1,0 l0-10.1c0-0.6-0.1-1.2-0.3-1.7c-0.2-0.5-0.6-1-1-1.5c-0.4-0.4-0.9-0.8-1.5-1c-0.5-0.2-1.1-0.3-1.7-0.3l0,14.6 c0,1.2,0.5,2.3,1.3,3.2C38.4,21.3,39.5,21.8,40.7,21.8L40.7,21.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 17.7,
    y: 35.1,
    width: 28.1,
    height: 4.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 17.7,
    y: 43.8,
    width: 14.3,
    height: 4.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 17.7,
    y: 26.3,
    width: 28.1,
    height: 4.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13,47.5v-37c0-2,1.6-3.6,3.6-3.6h15.1V2.5H16.6c-4.5,0-8.1,3.6-8.1,8.1v37H13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51,26.3v27.1c0,2-1.6,3.6-3.6,3.6H16.6c-2,0-3.6-1.6-3.6-3.6v-5.9H8.5v5.9c0,4.5,3.6,8.1,8.1,8.1h30.9 c4.5,0,8.1-3.6,8.1-8.1V26.3H51z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabase);
export default __webpack_public_path__ + "static/media/database.fb133db5394ea909c140b30716b6a810.svg";
export { ForwardRef as ReactComponent };